//
import { RFormFields } from '@/components/reusable_components/next'

//
import BranchOfficeModel from '@/models/General/GBranchOffice'
import CustomerModel from '@/models/Sale/SlCustomer'
import UserModel from '@/models/General/GUser'

// sl_customer_id", "pay_date_min", "pay_date_max".
export default new RFormFields(
  {
    name: 'number',
    type: 'text-field',
    props: {
      label: 'Factura',
    },
  },
  {
    name: 'g_branch_office_id',
    type: 'autocomplete-model',
    props: {
      itemText: 'name',
      itemValue: 'id',
      label: 'Origen',
      model: BranchOfficeModel,
      noObject: true,
      paramSearch: 'name',
    },
  },  
  {
    name: 'g_seller_user_id',
    type: 'autocomplete-model',
    props: {
      itemText: 'hr_employee_name_case',
      itemValue: 'id',
      label: 'Vendedor',
      model: UserModel,
      noObject: true,
    },
  },  
	{
		name: 'sl_customer_rut',
		type: 'text-field',
		props: {
			label: 'Rut del cliente',
		},
	},
  {
    name: 'sl_customer_id',
    type: 'autocomplete-model',
    props: {
      itemText: 'alias_name',
      itemValue: 'id',
      label: 'Cliente',
      model: CustomerModel,
      noObject: true,
    },
    trigger(ctx) {
      ctx.getField('sl_customer_branch_offices_id').props.items = ctx.getInput('sl_customer_id').getSelected().branch_offices
      ctx.$forceUpdate()
    },
  },
  {
    name: 'sl_customer_branch_offices_id',
    type: 'select',
    props: {
      label: 'Sucursal',
      items: [],
      itemText: 'address',
      itemValue: 'id',
      noObject: true,
    },
  },
  {
    name: 'status',
    type: 'select',
    props: {
      items: [
        'Pendiente',
        'Abonado',
        'Pagado',
        'Atrasado',
      ],
      label: 'Estado',
      multiple: true,
    },
  },
  {
    name: 'pay_date',
    type: 'date-field',
    props: {
      label: 'Vencimiento',
    },
  },
  {
    name: 'pay_date_min',
    type: 'date-field',
    props: {
      label: 'Desde',
    },
  },
  {
    name: 'pay_date_max',
    type: 'date-field',
    props: {
      label: 'Hasta',
    },
  },
)